import type { ComponentsOverrides, Theme } from "@mui/material";

export const MuiButtonLightStyleOverrides: ComponentsOverrides<Theme>["MuiButton"] =
  {
    root: () => ({
      borderRadius: "40px",
      textTransform: "none",
    }),

    containedPrimary: ({ theme }) => ({
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
      "&.Mui-disabled": {
        opacity: 0.4,
        color: theme.palette.common.white,
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.main,
        cursor: "not-allowed",
      },
    }),
    outlinedSecondary: ({ theme }) => ({
      color: theme.palette.text.secondary,
      borderColor: theme.palette.text.secondary,
      "&:hover": {
        backgroundColor: "transparent",
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
      },
      "&.Mui-disabled": {
        opacity: 0.4,
        color: theme.palette.text.secondary,
        borderColor: theme.palette.text.secondary,
        cursor: "not-allowed",
      },
    }),
    outlinedPrimary: ({ theme }) => ({
      color: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: "transparent",
        borderColor: theme.palette.primary.dark,
        color: theme.palette.primary.dark,
      },
      "&.Mui-disabled": {
        opacity: 0.4,
        color: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
        cursor: "not-allowed",
      },
    }),
    containedError: ({ theme }) => ({
      color: theme.palette.otherBackgroundLight.main,
      backgroundColor: theme.palette.error.main,
      "&:hover": {
        backgroundColor: theme.palette.error.dark,
      },
      "&.Mui-disabled": {
        opacity: 0.4,
        color: theme.palette.otherBackgroundLight.main,
        borderColor: theme.palette.error.main,
        cursor: "not-allowed",
      },
    }),
    textPrimary: ({ theme }) => ({
      color: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: "transparent",
        color: theme.palette.primary.dark,
      },
    }),
    sizeSmall: {
      paddingLeft: "1rem",
      paddingRight: "1rem",
      height: "40px",
    },
    sizeMedium: {
      paddingLeft: "2rem",
      paddingRight: "2rem",
      height: "48px",
    },
  };
